<template>
  <div class="show-clinical-questionnaire pt-2 pb-3">
    <div class="row">
      <div class="col-md-6 pl-0">
        <h6 class="is-bold text-evollu-gray-light mb-3">
          {{ title }}
        </h6>
      </div>

        <div class="col-md-6 text-right" v-if="value && value.updated_at !== null && value.updated_at !== undefined">
          <small>
            {{ $t('clinical.people.anamnesis.updated_at') }}
          </small>
          <small class="is-bold">
            {{$t('clinical.people.anamnesis.updated_by', {date: getExpressiveDate(value.updated_at), name: value.updated_by ? value.updated_by.name : ''})}}
          </small>
        </div>
    </div>

    <section v-if="value !== null && value !== undefined" class="px-2">
      <!-- Time Since Hearing Loss -->
      <div class="answer-wrapper">
        <label class="mb-0">
          {{ $t('clinical.people.anamnesis.time_since_hearing_loss') }}
        </label>
        <span class="is-bold">
          {{ getTextAnswer(value.time_since_hearing_loss) }}
        </span>
      </div>

      <!-- Right Hearing Loss Type -->
      <div class="answer-wrapper">
        <label>
          {{ $t('clinical.people.anamnesis.right_hearing_loss') }}:
        </label>
        <span class="is-bold">
          {{ getSingleOptionAnswer(formOptions.hearingLossTypeOptions, value.right_hearing_loss_type_id) }}
        </span>
      </div>

      <!-- Left Hearing Loss Type -->
      <div class="answer-wrapper">
        <label>
          {{ $t('clinical.people.anamnesis.left_hearing_loss') }}:
        </label>
        <span class="is-bold">
          {{ getSingleOptionAnswer(formOptions.hearingLossTypeOptions, value.left_hearing_loss_type_id) }}
        </span>
      </div>

      <!-- Feels Hearing Loss -->
      <div class="answer-wrapper">
        <label>
          {{ $t('clinical.people.anamnesis.feels_hearing_loss') }}
        </label>
        <span class="is-bold">
          {{ getSingleOptionAnswer(formOptions.commonOptions, value.feels_hearing_loss) }}
        </span>
      </div>

      <!-- Visited Health Professional -->
      <div class="answer-wrapper">
        <label>
          {{ $t('clinical.people.anamnesis.visited_health_professional') }}
        </label>
        <span class="is-bold">
          {{ getBooleanAnswer(value.visited_health_professional) }}
        </span>
      </div>

      <!-- Health Professional Obs -->
      <div class="answer-wrapper">
        <label>
          {{ $t('clinical.people.anamnesis.health_professional_obs') }}:
        </label>
        <span class="is-bold">
          {{ getTextAnswer(value.health_professional_obs) }}
        </span>
      </div>

      <!-- Pain in ears -->
      <div class="answer-wrapper">
        <label>
          {{ $t('clinical.people.anamnesis.pain_in_ears') }}
        </label>
        <span class="is-bold">
          {{ getBooleanAnswer(value.pain_in_ears) }}
        </span>
      </div>

      <!-- Ear Operation -->
      <div class="answer-wrapper">
        <label>
          {{ $t('clinical.people.anamnesis.previous_ear_operation') }}
        </label>
        <span class="is-bold">
          {{ getBooleanAnswer(value.previous_ear_operation) }}
        </span>
      </div>

      <!-- Ear Operation Obs -->
      <div class="answer-wrapper">
        <label>
          {{ $t('clinical.people.anamnesis.previous_ear_operation_obs') }}:
        </label>
        <span class="is-bold">
          {{ getTextAnswer(value.operation_obs) }}
        </span>
      </div>

      <!-- Takes Ear Medication -->
      <div class="answer-wrapper">
        <label>
          {{ $t('clinical.people.anamnesis.takes_medication_for_ears') }}
        </label>
        <span class="is-bold">
          {{ getBooleanAnswer(value.takes_medication_for_ears) }}
        </span>
      </div>

      <!-- Ear Medication Obs -->
      <div class="answer-wrapper">
        <label>
          {{ $t('clinical.people.anamnesis.medication') }}:
        </label>
        <span class="is-bold">
          {{ getTextAnswer(value.medication_obs) }}
        </span>
      </div>

      <!-- Recurring Otitis -->
      <div class="answer-wrapper">
        <label>
          {{ $t('clinical.people.anamnesis.recurring_otitis') }}
        </label>
        <span class="is-bold">
          {{ getBooleanAnswer(value.recurring_otitis) }}
        </span>
      </div>

      <!-- Otitis While Young -->
      <div class="answer-wrapper">
        <label>
          {{ $t('clinical.people.anamnesis.otities_while_young') }}
        </label>
        <span class="is-bold">
          {{ getBooleanAnswer(value.otities_while_young) }}
        </span>
      </div>

      <!-- Tinnitus Location -->
      <div class="answer-wrapper">
        <label>
          {{ $t('clinical.people.anamnesis.tinnitus_location') }}
        </label>
        <span class="is-bold">
          {{ getSingleOptionAnswer(formOptions.tinnitusLocationOptions, value.tinnitus_location_id) }}
        </span>
      </div>

      <!-- Tinnitus Type -->
      <div class="answer-wrapper">
        <label>
          {{ $t('clinical.people.anamnesis.tinnitus_type_id') }}:
        </label>
        <span class="is-bold">
          {{ getSingleOptionAnswer(formOptions.tinnitusTypeOptions, value.tinnitus_type_id) }}
        </span>
      </div>

      <!-- Tinnitus Tone Type -->
      <div class="answer-wrapper">
        <label>
          {{ $t('clinical.people.anamnesis.tinnitus_tone_type_id') }}:
        </label>
        <span class="is-bold">
          {{ getSingleOptionAnswer(formOptions.tinnitusToneTypeOptions, value.tinnitus_tone_type_id) }}
        </span>
      </div>

      <!-- Tinnitus Obs -->
      <div class="answer-wrapper">
        <label>
          {{ $t('clinical.people.anamnesis.tinnitus_obs') }}:
        </label>
        <span class="is-bold">
          {{ getTextAnswer(value.tinnitus_obs) }}
        </span>
      </div>

      <!-- Chronic Diseases -->
      <div class="answer-wrapper">
        <label>
          {{ $t('clinical.people.anamnesis.has_chronic_diseases') }}
        </label>
        <span class="is-bold">
          {{ getBooleanAnswer(value.chronic_diseases) }}
        </span>
      </div>

      <!-- Chronic Diseases Obs -->
      <div class="answer-wrapper">
        <label>
          {{ $t('clinical.people.anamnesis.chronic_diseases_obs') }}:
        </label>
        <span class="is-bold">
          {{ getTextAnswer(value.chronic_diseases_obs) }}
        </span>
      </div>

      <!-- Works in Noisy Environments -->
      <div class="answer-wrapper">
        <label>
          {{ $t('clinical.people.anamnesis.works_in_noisy_environments') }}
        </label>
        <span class="is-bold">
          {{ getBooleanAnswer(value.works_in_noisy_environments) }}
        </span>
      </div>

      <!-- Hobbies with Noisy Environments -->
      <div class="answer-wrapper">
        <label>
          {{ $t('clinical.people.anamnesis.hobbies_with_noisy_environments') }}
        </label>
        <span class="is-bold">
          {{ getBooleanAnswer(value.hobbies_with_noisy_environments) }}
        </span>
      </div>

      <!-- Family With Hearing Loss -->
      <div class="answer-wrapper">
        <label>
          {{ $t('clinical.people.anamnesis.family_with_hearing_loss') }}
        </label>
        <span class="is-bold">
          {{ getBooleanAnswer(value.family_with_hearing_loss) }}
        </span>
      </div>

      <!-- Family Relation -->
      <div class="answer-wrapper">
        <label>
          {{ $t('clinical.people.anamnesis.family_relation_type') }}:
        </label>
        <span class="is-bold">
          {{ getMultipleOptionAnswer(formOptions.familyRelationTypeOptions, value.family_relation_type_ids) }}
        </span>
      </div>

      <!-- Vertigo -->
      <div class="answer-wrapper">
        <label>
          {{ $t('clinical.people.anamnesis.vertigo') }}
        </label>
        <span class="is-bold">
          {{ getBooleanAnswer(value.vertigo) }}
        </span>
      </div>

      <!-- Previous Hearing Aid Type -->
      <div class="answer-wrapper">
        <label>
          {{ $t('clinical.people.anamnesis.previous_hearing_aid_type') }}
        </label>
        <span class="is-bold">
          {{ getSingleOptionAnswer(formOptions.previousHearingAidOptions, value.previous_hearing_aid_type_id) }}
        </span>
      </div>

      <!-- Previou Hearing Aid Brand -->
      <div class="answer-wrapper">
        <label>
          {{ $t('clinical.people.anamnesis.previous_hearing_aid_brand') }}:
        </label>
        <span class="is-bold">
          {{ getTextAnswer(value.previous_hearing_aid_brand) }}
        </span>
      </div>

      <!-- Previous Hearing Aid Model -->
      <div class="answer-wrapper">
        <label>
          {{ $t('clinical.people.anamnesis.previous_hearing_aid_model') }}:
        </label>
        <span class="is-bold">
          {{ getTextAnswer(value.previous_hearing_aid_model) }}
        </span>
      </div>

      <!-- Obs -->
      <div class="answer-wrapper">
        <label>
          {{ $t('clinical.people.anamnesis.obs') }}:
        </label>
        <span class="is-bold">
          {{ getTextAnswer(value.obs) }}
        </span>
      </div>

    </section>

    <section v-else class="px-2">
      <span>{{ $t('clinical.people.no_data') }}</span>
    </section>
  </div>
</template>

<script>
import * as AnamnesisOptions from './AnamnesisOptions'
export default {
  props: {
    value: {
      type: Object,
      required: false
    },
    title: {
      type: String,
      required: false,
      default: function () {
        return this.$t('clinical.people.anamnesis.about_hearing_loss')
      }
    }
  },
  data: function () {
    return {
      formOptions: AnamnesisOptions
    }
  },
  methods: {
    getExpressiveDate: function (value) {
      if (value) {
        if (this.$options.filters.isToday(value)) {
          return this.$t('date_helpers.today')
        } else {
          return this.$options.filters.localTime(value, `DD [${this.$t('date_helpers.day_of_month_separator')}] MMMM [${this.$t('date_helpers.day_of_month_separator')}] YYYY`, '', this.locale)
        }
      }
      return ''
    },
    getTextAnswer: function (answer, defaultValue = 'N/A') {
      return answer || defaultValue
    },
    getBooleanAnswer: function (answer, defaultValue = 'N/A') {
      return answer === null ? defaultValue : (answer === true ? this.$t('yes') : this.$t('no'))
    },
    getSingleOptionAnswer: function (options, answerId, defaultValue = 'N/A') {
      let option = null
      if (answerId !== null) {
        option = options.find(option => option.id === answerId)
        if (option) {
          option = this.$t(option.name)
        }
      }
      return option || defaultValue
    },
    getMultipleOptionAnswer: function (options, values, defaultValue = 'N/A') {
      let answer = null
      if (values) {
        answer = options.filter(opt => values.some(val => val === opt.id)).map(elem => this.$t(elem.name))
      }
      return answer ? answer.toString().replace(/,/g, ', ') : defaultValue
    }
  }
}
</script>

<style lang="scss">

@mixin for-desktop {
  @media (min-width: 766px) {
    @content;
  }
}

.answer-wrapper {
  display: flex;
  flex-direction: column;
  margin-bottom: 0.75rem;
  justify-content: flex-start;

  label {
    margin-bottom: 0rem;
  }

  @include for-desktop {
    flex-direction: row;
    align-items: center;

    label {
      max-width: 80%;
    }

    span {
      margin-left: 0.25rem;
    }
  }
}

</style>
